import styles from './style.css';

type Props = {
  text: string;
};

export const Copy = (props: Props) => {
  return <div className={styles.field}>{props.text}</div>;
};